/* מבנה מחלקה — משותף לקליינט ולשרת (השרת יצטרך אותו לאזור האישי). */

export const DEPARTMENT_SLUGS = [
  'strategy',
  'venture',
  'gov',
  'tech',
  'market',
  'finance',
  'hr',
  'connect',
] as const;

export type DepartmentSlug = (typeof DEPARTMENT_SLUGS)[number];

export interface Department {
  slug: DepartmentSlug;
  /** שם המחלקה כפי שמוצג בכותרת ובניווט */
  title: string;
  /** משפט התיאור הקצר שמתחת לכותרת */
  tagline: string;
  /** פסקאות גוף העמוד */
  paragraphs: string[];
  /** פסקת "הבידול שלנו" — מוצגת בהדגשה, קיימת רק בחלק מהמחלקות */
  differentiator?: string;
  /** רשימת השירותים המוצגת ברשת הממוספרת */
  services: string[];
  /** האם להציג קישור לעמוד היועצים */
  hasAdvisors: boolean;
  /** תמליל הכפתור בתחתית העמוד */
  ctaLabel: string;
  /** תקציר נפרד המוצג ברשת המחלקות בעמוד הבית — נוסח שונה מגוף העמוד */
  summary: string;
  /** יעד חיצוני במקום עמוד המחלקה הפנימי (קיים כיום רק ל-tech) */
  externalUrl?: string;
}
